import React from 'react';
import { Button } from './Button';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/oaQANTmLmdH94jWkAeshbq/LetLois_Logo_Wide_Lapels_Blue_Transparent_(1).png';
const CHARCOAL_TEXTURE_URL = 'https://cdn.magicpatterns.com/uploads/scC5pVG3EUePxKUfSG2TRr/Screenshot_2026-07-23_at_10.49.48_AM.png';
export function Header() {
  return <header className="w-full bg-[#111415]" style={{
    backgroundImage: `radial-gradient(ellipse 55% 180% at 50% 0%, rgba(21, 47, 74, 0.9) 0%, rgba(15, 28, 41, 0.72) 35%, rgba(17, 20, 21, 0.2) 72%), url('${CHARCOAL_TEXTURE_URL}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center top'
  }} data-id="element-114" data-mp="2nm5409nlcr7y">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10" data-id="element-115" data-mp="36b1wq93cbbo2">
        <a href="#" className="flex items-center" aria-label="LetLois home" data-id="element-116" data-mp="3ba4wpf4gqrp6">
          <img src={LOGO_URL} alt="LetLois" className="h-9 w-auto max-w-[148px] object-contain object-left sm:h-10 sm:max-w-[170px]" data-id="element-117" data-mp="3b81w615opg67" />
        </a>
        <Button variant="primary" data-id="element-118" data-mp="2wl4f4pbd24fo">Book a Call</Button>
      </div>
    </header>;
}